import { ApiClient } from '../api/ApiClient';
import { Config } from '../core/Config';

export class ClickTracker {
    private api: ApiClient;
    private config: Config;
    private onAuthError?: (error: unknown) => void;

    /**
     * @param onAuthError notified when a send fails (e.g. an expired session
     *   token), so the orchestrator can transparently recover the session
     *   instead of 401ing forever. The tracker still rethrows for the caller.
     */
    constructor(api: ApiClient, config: Config, onAuthError?: (error: unknown) => void) {
        this.api = api;
        this.config = config;
        this.onAuthError = onAuthError;
    }

    public async trackClick(viewId: string): Promise<void> {
        try {
            await this.api.trackClick(viewId);
            this.config.log(`Click tracked for view:`, viewId);
        } catch (error) {
            this.config.error(`Failed to track click:`, error);
            this.onAuthError?.(error);
            throw error;
        }
    }
}
